import { Fragment, useEffect, useState, useCallback } from 'react'
import * as React from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { useHistory } from 'react-router-dom'
import dayjs from 'dayjs'
import { useModal } from '@leroy-merlin-br/backyard-react-ui'

import { Spinner } from 'reactGarden/Spinner'

import { useResize } from 'reactUtils/hooks/use-resize'

import { Card, CardHeader } from 'lmcv/components/Card'
import { Actions as ActionsCustomers } from 'lmcv/redux/modules/customers'
import { Actions as ActionsCoupon } from 'lmcv/redux/modules/coupon'
import { ModalShare, ModalShareError } from 'lmcv/components/Modal'
import { useCloseModal } from 'lmcv/hooks/modal'
import { pluralize } from 'lmcv/modules/utils'

function ModalShareContainer ({ id, category, active }) {
  const history = useHistory()
  const dispatch = useDispatch()
  const { setModal } = useModal()
  const data = useSelector(state => state.coupon.get)
  const dataCoupon = useSelector(state => state.coupon.active, shallowEqual)
  const user = useSelector(state => state.user.get, shallowEqual)
  const customers = useSelector(state => state.customers.get, shallowEqual)

  const [isMobile] = useResize()
  const { handleOnClose } = useCloseModal()
  const [hasClients, setClients] = useState(false)
  const [customersList, setCustomersList] = useState([])
  const [isModalErrorOpen, setIsModalErrorOpen] = useState(false)
  const [modalMeta, setModalMeta] = useState({
    date: '',
    expire: '',
    button: {
      default: 'Ativar',
      active: 'Ativado'
    }
  })

  const onClickModalError = useCallback(
    onModalClose => {
      onModalClose()
      handleOnClose()
      setIsModalErrorOpen(false)
      history.push('/clientes')
    },
    [handleOnClose, history]
  )

  useEffect(() => {
    if (!customers.isRequest) {
      const customersFiltered = customers.payload.data.filter(item =>
        item.status.match('Ativo')
      )

      if (customersFiltered.length) {
        setClients(true)
        setCustomersList(customersFiltered)
      }
    }
  }, [customers])

  useEffect(() => {
    if (isModalErrorOpen) {
      return setModal({
        appElement: 'body',
        hasScroll: true,
        children: ({ onClose }) => (
          <ModalShareError
            onClose={onClose}
            onClick={() => onClickModalError(onClose)}
          />
        )
      })
    }
  }, [isModalErrorOpen, onClickModalError, setModal])

  useEffect(() => {
    dispatch(ActionsCoupon.get(id, category, active))
    dispatch(ActionsCustomers.getCustomers())
  }, [dispatch, id, category, active])

  useEffect(() => {
    if (!data.error && !data.isRequest) {
      const { expire, isActive, type, price } = data.payload

      const remainingDays = dayjs(expire).diff(
        dayjs().format('YYYY/MM/DD'),
        'day'
      )

      const remainingDaysText = `Expira ${
        remainingDays === 0
          ? 'hoje'
          : `em ${remainingDays} ${pluralize('dia', remainingDays > 1)}`
      }`

      if (type === 'percentage') {
        setModalMeta({
          date: (
            <Fragment>
              Valor do cupom {!isMobile && <br />}
              <strong>{`${price} pts`}</strong>
            </Fragment>
          ),
          expire: <Fragment>{remainingDaysText}</Fragment>
        })
      }

      if (type === 'money') {
        setModalMeta({
          date: !isActive && (
            <Fragment>
              Válido por <strong>30 dias</strong>
              <br />
              após a ativação
            </Fragment>
          ),
          expire: isActive && <Fragment>{remainingDaysText} </Fragment>,
          button: {
            default: `${price} pts`,
            active: 'Ativado'
          }
        })
      }
    }
  }, [data, data.error, data.isRequest, isMobile])

  if (data.isRequest) {
    return (
      <Card>
        <Spinner />
      </Card>
    )
  }

  if (data.error) {
    return (
      <Card>
        <CardHeader
          title="Ops, houve algum problema ao trazer as informações do seu cupom."
          message="Tenta novamente, mais tarde.."
        />
      </Card>
    )
  }

  const {
    thumbnail,
    title,
    description,
    rules,
    type,
    price,
    isActive,
    giftedBy
  } = data.payload
  const { isRequest } = dataCoupon

  const isCouponMoney = type === 'money'

  const customProps = {
    isDisabled: user.payload.points.actual < price
  }

  const modalProps = {
    id: id,
    title,
    description,
    rules,
    thumbnail,
    icon: isCouponMoney ? 'dollar_sign' : 'percent',
    text: modalMeta.date,
    textFooter: modalMeta.expire,
    buttonText: modalMeta.button,
    isLoading: isRequest,
    isActive,
    giftedBy,
    onClose: handleOnClose,
    toggleModalError: () => setIsModalErrorOpen(true),
    hasClients,
    customers: customersList,
    price,
    ...customProps
  }

  return (
    <React.Fragment>
      <ModalShare {...modalProps} />
    </React.Fragment>
  )
}

export default ModalShareContainer
